declare namespace $ {

	type $shm_listener__shm_hitalama_command_palette_1 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_command_palette['pointerdown_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_hitalama_hovered__hovered_shm_hitalama_command_palette_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_command_palette['panel_hovered'] >
		,
		ReturnType< $shm_hitalama_hovered['hovered'] >
	>
	type $mol_string__hint_shm_hitalama_command_palette_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_command_palette_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_command_palette['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_command_palette_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_command_palette['submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_command_palette_6 = $mol_type_enforce<
		({ 
			keydown( next?: ReturnType< $shm_hitalama_command_palette['search_keydown'] > ): ReturnType< $shm_hitalama_command_palette['search_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_view__sub_shm_hitalama_command_palette_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_command_palette['command_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__plugins_shm_hitalama_command_palette_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['plugins'] >
	>
	type $mol_view__sub_shm_hitalama_command_palette_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_dimmer__haystack_shm_hitalama_command_palette_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_command_palette['command_title'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_dimmer__needle_shm_hitalama_command_palette_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_command_palette['query'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	type $mol_button_minor__click_shm_hitalama_command_palette_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_command_palette['command_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_shm_hitalama_command_palette_13 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_command_palette['command_selected'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_shm_hitalama_command_palette_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $shm_hitalama_command_palette extends $mol_view {
		search_focus( ): any
		pointerdown_handler( ): any
		pointerdown_listener( ): $shm_listener
		panel_hovered( next?: boolean ): boolean
		Hovered( ): $shm_hitalama_hovered
		query( next?: string ): string
		submit( next?: any ): any
		search_keydown( next?: any ): any
		Search( ): $mol_string
		command_rows( ): readonly($mol_view)[]
		List( ): $mol_view
		Panel( ): $mol_view
		panel_visible( ): readonly(any)[]
		command_click( id: any, next?: any ): any
		command_selected( id: any): boolean
		command_title( id: any): string
		Command_label( id: any): $mol_dimmer
		opened( next?: boolean ): boolean
		selected_id( next?: string ): string
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
		Command_row( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=palette.view.tree.d.ts.map